import { isNodeDevEnvironment } from '@repo/common';
/**
 * Throws an error when a condition is true in development mode.
 * Used to catch invalid prop combinations or missing required props during development.
 *
 * Note: In production builds, calls to this function should be removed by the bundler
 * through dead code elimination when isDev() returns false.
 *
 * @param condition - The condition to check. If truthy, an error will be thrown.
 * @param componentName - The name of the component where the assertion is being performed.
 * @param message - The error message that will be shown if the condition is true.
 * @throws Throws an error with a message that includes the component name and the reason for the failure.
 *
 * @example
 * devAssert(
 *   isSubmitting && isDisabled,
 *   'Button',
 *   'isSubmitting cannot be true when isDisabled is true'
 * );
 */
export function devAssert(condition, componentName, message) {
    if (!isNodeDevEnvironment())
        return;
    if (condition) {
        throw new Error(`${componentName}: ${message}`);
    }
}
//# sourceMappingURL=dev-assert.js.map